import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames';

class FlexLayoutContainer extends PureComponent {
  render() {
    const { className, children } = this.props;

    /*
		In order to have any margins around the whole container NOT interfere with the negative margins of the container, we need to put it on a separate outermost div. The negative margins of the flex container itself ensure that boxes against the edges of the container are flush with the edge.
		*/
    return (
      <div className={classNames({ [className]: !!className })}>
        <div className="flex-layout__flex-container">{children}</div>
      </div>
    );
  }
}

FlexLayoutContainer.propTypes = {
  /**
   * optional className to apply to the outermost container (i.e. to add a margin around the whole container).
   */
  className: PropTypes.string,
};

// NOTE: Intended for use as parent of FlexLayoutBox to work properly.

export default FlexLayoutContainer;
